import { TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { capitaliseText } from "../../../helpers/StringHelpers"
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"
import NameValidator from "../../../services/validation/personal-and-contact-details-form/NameValidator"

const MAX_LENGTH_NAME = 66

function NricNameInputField(props: FormFieldProps<string>) {
    const { t } = useTranslation(`signup`)
    const { handleChange, errorText, defaultValue, isDisabled } = props
    const [error, setError] = useState(false)
    const [helperText, setHelperText] = useState<string | undefined>()

    const validateField = (value: string) => {
        const validationText = (new NameValidator()).validate(value)
        setHelperText(validationText)
        setError(validationText !== undefined)
    }

    const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        validateField(capitaliseText(event.target.value))
        handleChange(capitaliseText(event.target.value))
    }

    useEffect(() => {
        setError(errorText !== undefined)
        setHelperText(errorText ?? ``)
    }, [errorText, defaultValue])

    return (
        <TextField
            fullWidth
            id="nric-name-input"
            label={t(`name`)}
            variant="outlined"
            margin="normal"
            value={defaultValue}
            error={error}
            helperText={helperText ? t(helperText) : ``}
            onChange={handleOnChange}
            onBlur={handleOnChange}
            inputProps={{ textTransform: `uppercase`, maxLength: MAX_LENGTH_NAME }}
            disabled={isDisabled}
        />
    )
}

export default NricNameInputField